import { render, staticRenderFns } from "./lingxi.vue?vue&type=template&id=6dcab991&scoped=true"
import script from "./lingxi.vue?vue&type=script&lang=js"
export * from "./lingxi.vue?vue&type=script&lang=js"
import style0 from "./lingxi.vue?vue&type=style&index=0&id=6dcab991&prod&lang=scss&scoped=true"
import style1 from "./lingxi.vue?vue&type=style&index=1&id=6dcab991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcab991",
  null
  
)

export default component.exports